import { render } from "./ChartPager.vue?vue&type=template&id=3b527e6c&ts=true"
import script from "./ChartPager.vue?vue&type=script&lang=ts"
export * from "./ChartPager.vue?vue&type=script&lang=ts"

import "./ChartPager.vue?vue&type=style&index=0&id=3b527e6c&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__